var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgAi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.744 0.100397C1.78004 -0.0334658 1.96996 -0.0334654 2.006 0.100397L2.33436 1.31991C2.34693 1.3666 2.3834 1.40307 2.43009 1.41564L3.6496 1.744C3.78347 1.78004 3.78347 1.96996 3.6496 2.006L2.43009 2.33436C2.3834 2.34693 2.34693 2.3834 2.33436 2.43009L2.006 3.6496C1.96996 3.78347 1.78004 3.78347 1.744 3.6496L1.41564 2.43009C1.40307 2.3834 1.3666 2.34693 1.31991 2.33436L0.100397 2.006C-0.0334658 1.96996 -0.0334654 1.78004 0.100397 1.744L1.31991 1.41564C1.3666 1.40307 1.40307 1.3666 1.41564 1.31991L1.744 0.100397Z",
    fill: "#7000E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38319 1.78111C6.48411 1.4063 7.01589 1.4063 7.11681 1.78111L8.0362 5.19575C8.0714 5.32649 8.17351 5.4286 8.30424 5.4638L11.7189 6.38319C12.0937 6.48411 12.0937 7.01589 11.7189 7.11681L8.30424 8.0362C8.17351 8.0714 8.0714 8.17351 8.0362 8.30424L7.11681 11.7189C7.01589 12.0937 6.48411 12.0937 6.38319 11.7189L5.4638 8.30424C5.4286 8.17351 5.32649 8.0714 5.19575 8.0362L1.78111 7.11681C1.4063 7.01589 1.4063 6.48411 1.78111 6.38319L5.19575 5.4638C5.32649 5.4286 5.4286 5.32649 5.4638 5.19575L6.38319 1.78111Z",
    fill: "#7000E3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.c6cb3605.svg";
export { ForwardRef as ReactComponent };